import React, { useEffect, useState } from "react";
import { Crown, Download, Globe, Share2 } from "lucide-react";

const KEY = "rl_install_gate_seen";
const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const ua = () => navigator.userAgent || "";
const isMobile = () => /Android|iPhone|iPad|iPod/i.test(ua());
const isIOS = () => /iPhone|iPad|iPod/i.test(ua());
const inAppBrowser = () => /\bwv\b|WhatsApp|Instagram|FBAN|FBAV|Telegram|Line\//i.test(ua());
const chromeIntent = () => `intent://${window.location.host}${window.location.pathname}${window.location.search}#Intent;scheme=https;package=com.android.chrome;end`;
const isRefLink = () => { const q = new URLSearchParams(window.location.search); return !!(q.get("ref") || q.get("code") || /^\/(r|join|p)\//.test(window.location.pathname)); };
const fromSharedLink = () => { const q = new URLSearchParams(window.location.search); return isRefLink() || !!(q.get("src") || q.get("utm_source")); };

/* "App first": a shared FB / WhatsApp / agent link on a phone shows Install before the site. Installed users never see it. Master switch: Settings → link_install_first. */
export const InstallGate = () => {
  const [show, setShow] = useState(false);
  const [prompt, setPrompt] = useState(window.__deferredInstallPrompt || null);
  const [how, setHow] = useState(false);
  useEffect(() => {
    try {
      if (isStandalone() || !isMobile() || sessionStorage.getItem(KEY) || !fromSharedLink()) return;
      if (/^\/(admin|agent)/.test(window.location.pathname)) return;
      if (isRefLink()) { setShow(true); return; }  // agent / admin code links always go app-first
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/config`).then((r) => r.json()).then((c) => { if (c?.link_install_first) setShow(true); }).catch(() => {});
    } catch { /* ignore */ }
    const onAvail = () => setPrompt(window.__deferredInstallPrompt);
    const onInstalled = () => { try { sessionStorage.setItem(KEY, "1"); } catch {} setShow(false); };
    window.addEventListener("pwa-installable", onAvail); window.addEventListener("pwa-installed", onInstalled);
    return () => { window.removeEventListener("pwa-installable", onAvail); window.removeEventListener("pwa-installed", onInstalled); };
  }, []);
  if (!show) return null;
  const skip = () => { try { sessionStorage.setItem(KEY, "1"); } catch {} setShow(false); };
  const install = async () => {
    if (inAppBrowser() && !isIOS()) { window.location.href = chromeIntent(); return; }
    if (!prompt) return setHow(true);
    prompt.prompt();
    const res = await prompt.userChoice;
    window.__deferredInstallPrompt = null; setPrompt(null);
    if (res?.outcome === "accepted") skip();
  };
  return (
    <div className="fixed inset-0 z-[130] flex flex-col items-center justify-center p-6 text-center" style={{ background: "radial-gradient(120% 90% at 50% 0%, #2a2410 0%, #0b0b0f 55%, #050507 100%)" }} data-testid="install-gate">
      <div className="w-20 h-20 rounded-full flex items-center justify-center" style={{ background: "conic-gradient(from 180deg, #f5d77a, #b8860b, #ffe9a8, #a97a12, #f5d77a)" }}>
        <div className="w-[70px] h-[70px] rounded-full flex items-center justify-center bg-[#0b0b0f]"><Crown className="w-9 h-9 text-amber-300" /></div>
      </div>
      <div className="mt-5 text-[10px] tracking-[0.35em] text-amber-300/80 font-bold">GET THE APP</div>
      <h1 className="mt-1 font-display font-black text-3xl text-amber-200" data-testid="install-gate-title">ROYAL LAKSHMI</h1>
      <p className="mt-3 text-sm text-slate-300 max-w-xs">Results, booking & wallet — 1 tap from your home screen. Fast, works offline, instant win alerts.</p>
      <button onClick={install} className="mt-6 w-full max-w-xs rl-gold-bg font-black py-3.5 rounded-2xl flex items-center justify-center gap-2 text-base active:scale-95 transition-transform" data-testid="install-gate-install-btn">
        <Download className="w-5 h-5" />{inAppBrowser() && !isIOS() ? "Open in Chrome & Install" : isIOS() ? "How to install (iPhone)" : "Install App"}
      </button>
      {(how || isIOS()) && (
        <div className="mt-4 rounded-2xl bg-white/10 border border-white/15 p-3 text-left text-xs text-slate-200 max-w-xs" data-testid="install-gate-howto">
          {isIOS() ? <>1. Tap <Share2 className="w-3.5 h-3.5 inline text-sky-300" /> <b>Share</b> at the bottom of Safari<br />2. Choose <b>"Add to Home Screen"</b><br />3. Tap <b>Add</b> — ROYAL LAKSHMI appears on your home screen</>
            : <>Tap Chrome menu <b>⋮</b> → <b>"Install app"</b> / <b>"Add to Home screen"</b></>}
        </div>
      )}
      <button onClick={skip} className="mt-5 text-xs text-slate-400 underline flex items-center gap-1" data-testid="install-gate-continue-web"><Globe className="w-3.5 h-3.5" />Website-லயே தொடரவும் · Continue on website</button>
    </div>
  );
};
